
<dashboard-card [title]="'Orders Created'" [soFarAchieved]="totalOrderCreated" [dailyTarget]="minOrderToCreate" [diffInDays]="diffInDays" [dataItems]="dataItems"></dashboard-card>